import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AuthConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'error'>('verifying');

  useEffect(() => {
    const tokenHash = searchParams.get('token_hash');
    const type = searchParams.get('type');

    if (!tokenHash || !type) {
      setStatus('error');
      return;
    }

    supabase.auth
      .verifyOtp({ token_hash: tokenHash, type: type as 'signup' | 'recovery' | 'invite' })
      .then(({ error }) => {
        if (error) {
          setStatus('error');
          return;
        }
        // Invited users have no password yet — same "set a password" screen as recovery.
        navigate(type === 'recovery' || type === 'invite' ? '/auth/reset-password' : '/onboarding', { replace: true });
      });
  }, [searchParams, navigate]);

  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-2xl font-bold text-foreground">Link expired or invalid</h1>
          <p className="text-muted-foreground">
            This confirmation link is no longer valid. Request a new one and try again.
          </p>
          <Button onClick={() => navigate('/auth')}>Back to sign in</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default AuthConfirm;
